<template>
  <div
    class="dependentdropdown__panel"
  >
    <Heading
      v-if="hasHeading"
      :title="headingTitle"
    />
    <div
      :class="['dependentdropdown__form', {'dependentdropdown__form--row' : displayHoriz}]"
    >
      <slot />
      <div class="dependentdropdown__field">
        <Button
          v-if="hasCta"
          :text="buttonText"
          @related-dropdown-click="$emit('submit-related-dropdown')"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import Heading from './Heading.vue';
  import Button from './Button.vue';
  export default {
    name: 'RelatedDropdownPanel',
    components: {
      Heading,
      Button
    },
    props: {
      displayHoriz: {
        type: Boolean,
        default: false
      },
      hasHeading: {
        type: Boolean,
        default: true
      },
      headingTitle: {
        type: String,
        default: ''
      },
      hasCta: {
        type: Boolean,
        default: true
      },
      buttonText: {
        type: String,
        default: ''
      }
    }
  };
</script>
